module.exports = __webpack_public_path__ + "img/临颍县-c.0cba27a2.png";